export default __webpack_public_path__ + "static/media/enghien08.dafee727.jpg";